module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/kv_icon_arrow-33dc14ae59ecdd8fbbd760ec796dd6ae.svg";